<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/cloud-banner.png`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">云安全解决方案</h2>
							<h4 class="text-left color-white">更安全、更稳定、更可靠</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">云安全解决方案</h2>
				<div style="margin-top: 48px; font-size: 18px">
					DDOS高防IP防御服务，更安全，更稳定；大带宽多线BGP节点集群，资源保障充足多线分布式防御系统不用SDK实现盾的防CC效果。核心产品包括：DDOS高防IP、WEB应用防火墙、DDOS防火墙。
				</div>
			</div>
		</div>


		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div style="margin-top: 48px; font-size: 18px">
					<div class="function-inner">
						<div class="edit-container">
							<ul class="clearfix">
								<li>
									<div class="block-box js-m delay1 animate">
										<div class="title">DDOS高防IP</div>
										<div class="cont">针对互联网服务器（包括公有云、IDC主机）在遭受大流量DDOS攻击后导致服务不可用的情况下，推出的付费服务，用户可通过配置高防IP，将攻击流量引流到高防IP，确保源站的稳定可靠性。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay2 animate">
										<div class="title">Web应用防火墙</div>
										<div class="cont">针对网站或者APP的业务流量进行恶意特征识别及防护，将正常、安全的流量回溯到服务器。避免网站服务器被恶意入侵，保障业务的核心数据安全，解决恶意攻击导致的服务器异常问题。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">DDOS防火墙</div>
										<div class="cont">是高防IP产品的核心基础，拥有单台80Gbps/U、集群1.92Tbps/机柜的清洗密度，相对于同类产品具有支持分布式部署架构、虚拟化Layer4/Lay-er7/WAF软件架构、定制化CC防御等特性，可运用于IDC、大型企业等各种私有化部署。</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">应用场景</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">网络游戏</div>
										<div class="t2">网络游戏一直是DDoS/CC攻击的重灾区，并且也是对防护效果、网络质量要求最高的行业，共启高防通过大带宽BGP防护网络，多机房多线路同步防御，肉鸡行为以及无SDK加密水印三重防御CC的技术，为客户提供高质量的防御方案。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">智慧城市</div>
										<div class="t2">智慧城市项目在落地过程中经常会遇到竞争对手的恶意攻击，而车牌识别、缴费等部署在公网对外提供服务的接口，是黑客攻击的重点，共启高防通过业务行为分析、肉鸡地域检测等方式为智慧城市项目提供完善的防护方案。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">电商平台</div>
										<div class="t2">电商APP、小程序、公众号等业务的支付、搜索等接口经常会面临应用层CC攻击，共启高防定制化的肉鸡行为检测，攻击报文特征深度检验技术为电商平台提供了强有力的防护方案。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">互联网金融</div>
										<div class="t2">互联网金融由于其行业特殊性，其对高防平台的稳定性要求极高，共启高防多机房联动共同防御方式，保证单一机房故障时业务不受影响，为互金提供坚若磐石的防御方案。</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/cloud1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.edit-container {
	position: relative;
	ul {
		margin: 0 -10px;
		display: block;
		li {
			display: inline-block;
			vertical-align: top;
			width: 33.333%;
			padding: 0 10px;
			text-align: left;
			margin-top: 15px;

			.block-box {
				padding: 34px 42px;
				position: relative;
				font-size: 16px;
				background-color: #f7f9fc;
				box-shadow: 0 10px 12px rgba(148, 160, 175, 0.33);
				border-radius: 8px;
				overflow: hidden;

				&:before {
					content: '';
					width: 100%;
					height: 6px;
					background: linear-gradient(to right, #c60c1a, #2270b2);
					position: absolute;
					left: 0;
					bottom: 0;
				}

				.title {
					font-size: 20px;
					font-weight: bold;
					height: 60px;
				}

				.cont {
					line-height: 1.8;
					height: 160px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 6;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
}

.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}

}

.swiper-container {
	width: 100%;
	height: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		margin-top: 10%;
	}
	:deep(.swiper-pagination) {
		top: 70%;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
